import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../api';
import './AppealDetail.css';
import backIcon from '../../assets/backspace-icon.png';

function AppealDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [appeal, setAppeal] = useState(null);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    const fetchAppeal = async () => {
      try {
        const res = await api.get(`/admin/appeals/${id}`);
        setAppeal(res.data);
      } catch (err) {
        console.error('❌ Failed to load appeal:', err);
      }
    };

    fetchAppeal();
  }, [id]);

  const handleReinstate = async () => {
    if (!appeal || !appeal.userId) return;

    const confirm = window.confirm(`Reinstate ${appeal.username}?`);
    if (!confirm) return;

    setProcessing(true);
    try {
      await api.patch(`/admin/users/${appeal.userId}/status`, { status: null });
      await api.delete(`/admin/appeals/${id}`);
      navigate('/admin/appeals');
    } catch (err) {
      console.error('❌ Failed to reinstate user:', err);
    } finally {
      setProcessing(false);
    }
  };


const handleReject = async () => {
  if (!appeal || !appeal.userId) return;

  const confirm = window.confirm(`Reject this appeal from ${appeal.username}?`);
  if (!confirm) return;

  setProcessing(true);
  try {
    // ✅ Soft rejection: send feedback + delete appeal (backend handles it)
    await api.post(`/admin/appeals/${id}/reject`, {
      userId: appeal.userId,
      reason: 'Your merchant appeal was reviewed and rejected. You may reapply again later.'
    });

    navigate('/admin/appeals');
  } catch (err) {
    console.error('❌ Failed to reject appeal:', err);
  } finally {
    setProcessing(false);
  }
};


  if (!appeal) return <p>Loading appeal...</p>;

  return (
    <div className="appeal-detail">
      <div className="appeal-detail-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="appeal-detail-back-icon"
          onClick={() => navigate(-1)}
        />
        <h2>{appeal.username}</h2>
      </div>

      <div className="appeal-detail-body">
        <p><strong>Role:</strong> {appeal.role}</p>
        <p><strong>Submitted:</strong> {new Date(appeal.createdAt).toLocaleString()}</p>
        <div className="appeal-message-box">
          <p>{appeal.message}</p>
        </div>

        <div className="appeal-action-row">
          <button
            className="reinstate-appeal-btn"
            onClick={handleReinstate}
            disabled={processing}
          >
            Reinstate
          </button>
          <button
            className="reject-appeal-btn"
            onClick={handleReject}
            disabled={processing}
          >
            Reject
          </button>
        </div>
      </div>
    </div>
  );
}

export default AppealDetail;
